import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "./context/ThemeProvider";
import { LoaderProvider } from "./context/LoaderContext";
import Pages from "./context/Pages";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <Pages>
        <LoaderProvider>
          <App />
        </LoaderProvider>
      </Pages>
    </ThemeProvider>
  </React.StrictMode>
);
reportWebVitals();
